import { forwardRef } from 'react';
import { IconButton } from 'modules/IconButton';
import { Falcon } from 'modules/macro';
export const TableRowCollapseButton = forwardRef((props, ref) => {
    const { open, onClick } = props;
    const icon = open ? <Falcon icon="chevron-up"/> : <Falcon icon="chevron-down"/>;
    return (<IconButton ref={ref} size="small" onClick={onClick} aria-expanded={open} appearance="ghost">
      {icon}
    </IconButton>);
});
